import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import BuildIcon from '@mui/icons-material/Build';

interface MaintenancePageProps {
  message?: string;
}

const MaintenancePage: React.FC<MaintenancePageProps> = ({ message }) => {
  useEffect(() => {
    document.title = 'メンテナンス中 - PULSE';
  }, []);

  return (
    <>
      <Helmet>
        <title>メンテナンス中 - PULSE</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Box sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        px: 3,
      }}>
        <BuildIcon sx={{ fontSize: 40, color: 'text.disabled', mb: 2 }} />
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          メンテナンス中
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', maxWidth: 400 }}>
          {message || '現在メンテナンス中です。しばらくお待ちください。'}
        </Typography>
      </Box>
    </>
  );
};

export default MaintenancePage;
